import type { ExtendedTextFieldProps } from 'components/TextField';
import i18n from 'i18n';
import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import TextField from 'components/TextField';

type CustomTextFieldI = ExtendedTextFieldProps & {
  rows?: number;
  label: string;
  className?: string | undefined;
};

const CustomTextField: FunctionComponent<CustomTextFieldI> = ({
  rows,
  className,
  ...props
}: CustomTextFieldI) => {
  const { dir } = useSelector((state: $Lns.DefaultState) => state.default);
  const direction = dir ?? i18n.dir();

  return (
    <TextField
      fullWidth
      variant="outlined"
      rows={rows || 1}
      multiline={!!rows && rows > 1}
      id={props.name}
      className={`${direction} ${className}`}
      {...props}
    />
  );
};

export default CustomTextField;

CustomTextField.defaultProps = {
  rows: undefined,
  className: undefined
};
